import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Stack } from '@mui/material';
import { useState } from 'react';
import { DialogWrapper } from '../../../common/DiaglogWrapper';
import { ParameterSelector } from './ParameterSelector';
export const ParameterSelectorPopup = () => {
    const [showPopup, setShowPopup] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsx(Stack, { direction: 'row', children: _jsx(Button, { variant: "contained", onClick: () => setShowPopup(true), children: "Request a report" }) }), _jsx(DialogWrapper, { header: "Set request parameters", open: showPopup, setClosed: () => setShowPopup(false), children: _jsx(ParameterSelector, { hidePopup: () => setShowPopup(false) }) })] }));
};
